import { message } from 'ant-design-vue';

// 消息配置
message.config({
    top: window.innerHeight / 2 - 100 + 'px',
    duration: 2,
    maxCount: 3,
});